import React from 'react';
import _ from 'lodash';
import { formats } from '~/helper';
import { Card, CardContainer } from '~/views/dashboard-supplier/styles';

function Cards({ model, goToPersons, goToEvents }) {
  return (
    <CardContainer>
      <Card color='#fd9006d9' onClick={goToPersons}>
        <span className='title'>Colaboradores</span>
        <div className='row'>
          <div className='values'>
            <span>{formats.number(_.get(model, 'cards.persons.total'))}</span>
            <label>Total</label>
          </div>
          <div className='values'>
            <span>{formats.number(_.get(model, 'cards.persons.actives'))}</span>
            <label>Ativos</label>
          </div>
        </div>
      </Card>

      <Card color='#d00db7' onClick={goToEvents}>
        <span className='title'>Eventos</span>
        <div className='row'>
          <div className='values'>
            <span>{formats.number(_.get(model, 'cards.events.total'))}</span>
            <label>Total</label>
          </div>
          <div className='values'>
            <span>{formats.number(_.get(model, 'cards.events.available'))}</span>
            <label>Disponíveis</label>
          </div>
        </div>
      </Card>
    </CardContainer>
  );
}

export default Cards;
